import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminroutes } from './components/admin/admin-routing.component';
import { AdminLayoutComponent, PublicLayoutComponent, DistributorLayoutComponent } from './containers';
import { RolGuard } from './guards/rol.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login/:idUser/:token',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'distributor-login/:idUser/:token/:idBudget',
    loadChildren: () => import('./components/distributor/login/distributor-login.module').then(m => m.DistributorLoginModule)
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./components/public/public.module').then(m => m.PublicModule), data: { animation: 'public' } }
    ]
  },
  {
    path: 'distributor',
    component: DistributorLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./components/distributor/distributor.module').then(m => m.DistributorModule), data: { animation: 'distributor' } }
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: adminroutes,
    canActivate: [RolGuard]
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
